module.exports = __webpack_public_path__ + "static/diy_recipe_dropbear_snot-1e0d2638d2c3177371b8a8b1d73eb414.pdf";